/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{property as r}from"./property.js";function o(o,t){const e=t?{...t,source:o}:o;return r({aliasOf:e})}export{o as aliasOf};
